import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import cogIcon from "../../icons/cog.svg";
import manIcon from "../../icons/man.svg";
import vanIcon from "../../icons/van.svg";
import calanderIcon from "../../icons/calendar.svg";
import listIcon from "../../icons/list.svg";
import envelopIcon from "../../icons/envelope.svg";
import smartPhoneIcon from "../../icons/smartphone.svg";
import lockIcon from "../../icons/lock.svg";
import lineChartIcon from "../../icons/line-chart.svg";
import { confirm, showSpinner, closeSpinner } from "../modules/Dialogs";
import { logOutUser } from "../modules/Authentication";

const Navigation = ({ userDetails, logOut }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    confirm(
      "Log Out",
      "Are you sure you want to log out?",
      "Cancel",
      "Log Out",
      () => {
        showSpinner();
        const theUser = {
          accountInfo: {
            username: userDetails.accountInfo.username,
            email: userDetails.accountInfo.email,
          },
        };
        logOutUser(theUser, (resStatus) => {
          closeSpinner();
          localStorage.removeItem("userDetailsAdmin");
          sessionStorage.clear();
          if (logOut) logOut();
          navigate("/signin", { replace: true });
        }, userDetails.jwttoken);
      }
    );
  };
  return (
    <div className="l-base-layout__menu">
      {userDetails.jwttoken != null &&
      userDetails.accountInfo.username != null ? (
        <div className="c-navigation c-navigation--scrollable">
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname === "/"
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            exact="true"
            to="/"
          >
            <img
              className={window.location.pathname === "/" && "img_invert"}
              src={cogIcon}
              alt=""
            />
            Home
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/client")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/clients"
          >
            <img
              className={
                window.location.pathname.startsWith("/client") && "img_invert"
              }
              src={manIcon}
              alt=""
            />
            Clients
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/mav")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/mavs"
          >
            <img
              className={
                window.location.pathname.startsWith("/mav") && "img_invert"
              }
              src={vanIcon}
              alt=""
            />
            MAVs
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/job")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/jobs"
          >
            <img
              className={
                window.location.pathname.startsWith("/job") && "img_invert"
              }
              src={calanderIcon}
              alt=""
            />
            Jobs
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/quote")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/quotes"
          >
            <img
              className={
                window.location.pathname.startsWith("/quote") && "img_invert"
              }
              src={listIcon}
              alt=""
            />
            Quotes
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/message")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/messages"
          >
            <img
              className={
                window.location.pathname.startsWith("/message") && "img_invert"
              }
              src={envelopIcon}
              alt=""
            />
            Messages
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/transfers")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/transfers"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5"></path>
              <path d="M18 12h.01"></path>
              <path d="M19 22v-6"></path>
              <path d="m22 19-3-3-3 3"></path>
              <path d="M6 12h.01"></path>
              <circle cx="12" cy="12" r="2"></circle>
            </svg>
            <div className="mt-12">Transfers</div>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive ||
              window.location.pathname.startsWith("/issues-resolutions")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/issues-resolutions"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="43"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-shield-alert nav-link-icon"
              >
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
              </svg>
            </div>
            Issues & Resolutions
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/discounts")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/discounts"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="43"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-circle-percent nav-link-icon"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="m15 9-6 6"></path>
                <path d="M9 9h.01"></path>
                <path d="M15 15h.01"></path>
              </svg>
            </div>

            Discounts
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/referrals")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/referrals"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="43"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-ticket-percent nav-link-icon"
              >
                <path d="M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                <path d="M9 9h.01"></path>
                <path d="m15 9-6 6"></path>
                <path d="M15 15h.01"></path>
              </svg>
            </div>
            Referrals
          </NavLink>

        <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/notifications")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/notifications"
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="43"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-bell nav-link-icon"
                aria-hidden="true"
              >
                <path d="M10.268 21a2 2 0 0 0 3.464 0"></path>
                <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path>
              </svg>
            </div>
            Notifications
          </NavLink> 

          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/report")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/reports"
          >
            <img
              className={
                window.location.pathname.startsWith("/report") && "img_invert"
              }
              src={lineChartIcon}
              alt=""
            />
            Reports
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/push")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            activeclassname="is-active"
            to="/pushNotifications"
          >
            <img
              className={
                window.location.pathname.startsWith("/push") && "img_invert"
              }
              src={smartPhoneIcon}
              alt=""
            />
            Push
          </NavLink>

          <div
            className="c-navigation__item"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            <img src={lockIcon} alt="" />
            Log Out
          </div>
        </div>
      ) : (
        <div className="c-navigation">
          <NavLink
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith("/signin")
                ? "c-navigation__item active"
                : "c-navigation__item"
            }
            to="/signin"
          >
            <img
              className={
                window.location.pathname.startsWith("/signin") && "img_invert"
              }
              src={lockIcon}
              alt=""
            />
            Sign In
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default Navigation;
